import { createContext, Dispatch, SetStateAction } from "react";
import { MachineDocument } from "../Types/dashboardTypes";

type MachineDocumentsContextType = {
  machineDocuments: MachineDocument[] | undefined;
  setMachineDocuments: Dispatch<SetStateAction<MachineDocument[] | undefined>>;
};
const initialState = {
  machineDocuments: [],
  setMachineDocuments: () => [],
};
const MachineDocumentContext = createContext<MachineDocumentsContextType>(initialState);

export default MachineDocumentContext;
